/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-video/bulbvideo
 */

import { Plugin } from 'ckeditor5';
import BulbVideoEditing from './bulbvideoediting';
import BulbVideoUI from './bulbvideoui';
import BulbVideoToolbar from './bulbvideotoolbar';

/**
 * The video plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbVideo extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbVideoEditing, BulbVideoUI, BulbVideoToolbar] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbVideo' as const;
  }
}
